import EventsBody from './EventsBody';

const View = (props) => <EventsBody {...props} />;

export default View;
